// 2048 page entry; the daily is one 4 by 4 board per local date with the same opening tiles for everyone.
import { Twenty48Game } from "../twenty48/ui"
import { fetchDaily, mountCalendar, pageDate, updateLabel } from "../lib/daily"

async function start(): Promise<void> {
  const board = document.getElementById("board")
  if (!board) return
  const game = board.dataset.dailyGame
  if (!game) {
    ;(window as unknown as { dtGame?: Twenty48Game }).dtGame = new Twenty48Game(board)
    return
  }
  const { date } = pageDate(board)
  updateLabel(date)
  const daily = await fetchDaily<{ seed: string }>(game, date)
  // Reserve: if a file is missing, every player still gets the same board for that date.
  const seed = daily?.seed ?? `reserve:${game}:${date}`
  ;(window as unknown as { dtGame?: Twenty48Game }).dtGame = new Twenty48Game(board, { game, date, seed })
  mountCalendar(game, "/2048")
}

void start()
